import React from 'react';
import {Bar} from 'react-chartjs-2';
import {colors} from '@mui/material';

export default function AdminBarChart({ labels, data, label, color }) {
    const chartColor = color || colors.indigo[500];

    const chartData = {
        labels: labels,
        datasets: [{
            label: label,
            backgroundColor: chartColor,
            maxBarThickness: 24,
            data: data,
        }],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            xAxes: [{
                gridLines: { display: false },
            }],
            yAxes: [{
                ticks: { beginAtZero: true, precision: 0 },
                gridLines: { borderDash: [2], drawBorder: false },
            }],
        },
        tooltips: { intersect: false, mode: 'index' },
    };

    return (
        <div style={{ height: 250 }}>
            <Bar data={chartData} options={options} />
        </div>
    );
}
